import React, { useState } from 'react';
import { Tabs, Input } from 'antd';

import './Search.css';

export default function Search() {
  const [activeKey, setActiveKey] = useState('https://www.360ep.cn/mall/search.php?moduleid=16&spread=0&kw=');

  const handleSearch = (value) => {
    //console.log(`Searching for tab ${activeKey}, value: ${value}`);
    window.open(activeKey + value, '_blank', 'noopener,noreferrer');
  };

  const tabItems = [
    {
      key: 'https://www.360ep.cn/mall/search.php?moduleid=16&spread=0&kw=',
      tab: '供应',
      placeholder: '请输入品名和牌号关键字',
    },
    {
      key: 'https://www.360ep.cn/mall/psearch.php?moduleid=16&spread=0&kw=',
      tab: '价格',
      placeholder: '请输入品名和牌号关键字获取价格',
    },
    {
      key: 'https://www.360ep.cn/news/search.php?moduleid=21&spread=0&kw=',
      tab: '资讯',
      placeholder: '请输入信息关键字',
    },
    {
      key: 'https://www.360ep.cn/company/search.php?moduleid=4&spread=0&kw=',
      tab: '公司',
      placeholder: '请输入品名，牌号或生产企业关键字',
    },
  ];

  return (
    <div className="container">
      <div className="image-container">
        <a href="https://www.360ep.cn">
          <img src="https://www.360ep.cn/skin/360ep/image/logo.jpg" alt="官网" />
        </a>
      </div>
      <div className="content-container">
        <Tabs
          activeKey={activeKey}
          onChange={(key) => setActiveKey(key)}
          className="tabs"
          items={tabItems.map((item) => ({
            key: item.key,
            label: item.tab,
            children: (
              <Input.Search
                className="input"
                placeholder={item.placeholder}
                onSearch={handleSearch}
              />
            ),
          }))}
        />
      </div>
    </div>
  );
}
